export default __webpack_public_path__ + "static/media/loader.0261833c.gif";